import { cn } from '@agavi/ui';
import { useTranslation } from 'react-i18next';

import { Button } from '@/components/ui/button';

/**
 * 404 Not Found page.
 *
 * Displayed when no route matches the current URL.
 */
function NotFoundPage() {
  const { t } = useTranslation();
  return (
    <div className='flex min-h-[60vh] items-center justify-center'>
      <div
        className={cn(
          'w-full max-w-md rounded-lg border border-ws-border bg-ws-surface text-ws-text shadow-sm'
        )}
      >
        <div className='flex flex-col space-y-1.5 p-6'>
          <h3 className='text-center text-2xl font-semibold leading-none tracking-tight'>
            {t('notFound.title')}
          </h3>
        </div>
        <div className='p-6 pt-0 space-y-4'>
          <p className='text-center text-ws-muted'>
            {t('notFound.message')}
          </p>
        </div>
        <Button>salut</Button>
      </div>
      <Button>salut</Button>
    </div>
  );
}

export default NotFoundPage;
